import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import sortBy from 'lodash/sortBy';
import last from 'lodash/last';
import upperCase from 'lodash/upperCase';

import { View } from 'react-native';
import { Card, CardBody, CardHeader } from '@dbk/ui-card';
import { FormattedMessage } from '@dbk-legacy/format';
import { createContainer } from '@dbk-legacy/muster/react';
import Text, { Large } from '@dbk/ui-text';
import format from 'date-fns/format';
import { ChangeIndicatedPercent } from '../../../components/common/number';
import { NO_DATA_TEXT, PALETTE } from '../../../constants';

import {
  scaleBar,
  XAxis,
  YAxis,
  BarChart,
  Bar,
  Grid,
  Chart,
  LineChart,
} from '@dbk/ui-charts';

import Interactions from './interactions';
import NoDataChart from '../../common/no-data-chart';
import styles from './cumulative-chart.styles';

class CumulativeChart extends PureComponent {
  constructor(props) {
    super(props);
  }

  static propTypes = {
    ...Chart.propTypes,
    bars: PropTypes.arrayOf(PropTypes.shape({
      titleText: PropTypes.string,
      valueText: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
      value: PropTypes.number,
      incYear: PropTypes.number
    })),
    cumulativeData: PropTypes.arrayOf(PropTypes.shape({
      titleText: PropTypes.string,
      valueText: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
      value: PropTypes.number,
      incYear: PropTypes.number
    })),
    screen: PropTypes.shape({
      isSmall: PropTypes.bool,
      width: PropTypes.number,
      height: PropTypes.number,
    }),
    onInteractionChange: PropTypes.func,
    selectedInteractionValue: PropTypes.number,
    margins: PropTypes.object,
  };

  static defaultProps = {
    bars: [],
    data: [],
    cumulativeData: [],
    margins: { left: 43, right: 0, top: 54, bottom: 30 },
  };

  createResultantData(barData, lineData) {
    let result = [];
    barData.forEach(function (item, i) {
      result.push(item);
    });
    result.forEach(function (item, j) {
      item.cumulativeVal = lineData[ j ].value;
      item.cumulativeText = lineData[ j ].titleText;
    });
    return result;
  }

  getOuterComponents() {
    const {
      selectedInteractionValue,
      onInteractionChange,
      margins,
      bars,
      cumulativeData,
      outerComponents,
      i18n: { messages }
    } = this.props;

    const noDataMarginTop = margins && margins.top ? margins.top * -1 : 0;
    const prepareDataInteraction = (cumulativeData && bars) ? this.createResultantData(bars, cumulativeData) : bars;

    const chartOuterComponents = prepareDataInteraction.length > 0
      ? <Interactions
        currency="test1"
        key="interactions"
        data={prepareDataInteraction}
        selectedValue={selectedInteractionValue}
        onChange={onInteractionChange}
        messages={messages}
      />
      : <NoDataChart
        key="no-data"
        marginTop={noDataMarginTop}
        messages={messages}
      />;

    if (outerComponents) {
      return [
        ...[ chartOuterComponents ],
        ...outerComponents,
      ];
    }
    return chartOuterComponents;
  }

  render() {
    const { bars, selectedInteractionValue, cumulativeData, displayedCurrency, perfStartDate,screen, i18n: { messages } } = this.props;

    const notNullData = bars.filter(bar => bar.value != null);
    if (bars === null || cumulativeData === null || bars.length === 0 || cumulativeData.length === 0 || notNullData.length === 0) {
      return (
        <View style={styles.alignCenter}>
          <Large>
            {messages[ NO_DATA_TEXT ]}
          </Large>
        </View>
      );
    }
    const startDate = perfStartDate? format(perfStartDate , 'DD.MM.YYYY'): null;
    const prepareDataInteraction = (cumulativeData && bars) ? this.createResultantData(bars, cumulativeData) : bars

    if (cumulativeData.length > 0 && bars.length > 0) {
      const data1 = cumulativeData.map((row, index) => ({
        ...row,
        index,
      }));

      let chartDomain1 = {};

      let sortedData1 = sortBy(data1, item => item.value);
      sortedData1 = sortedData1.filter(data => data.value != null);

      const dataCount1 = cumulativeData.length;

      if (dataCount1 > 0) {

        let minVal1 = 0;
        // check if the min value is below Zero , then adjust the buffer of the domain chart
        if (sortedData1[ 0 ].value < 0) {
          minVal1 = sortedData1[ 0 ].value + sortedData1[ 0 ].value * .5;
        }
        chartDomain1 = {
          min: minVal1,
          max: last(sortedData1).value + last(sortedData1).value * .25
        };
      }

      // Find real min and max values

      const barData = bars.map((row, index) => ({
        ...row,
        index,
      }));

      let barDomain = {};

      let sortedBarData = sortBy(barData, item => item.value);
      sortedBarData = sortedBarData.filter(data => data.value != null);

      const barCount = bars.length;

      if (barCount > 0) {

        let minVal1 = 0;
        // check if the min value is below Zero , then adjust the buffer of the domain chart
        if (sortedBarData[ 0 ].value < 0) {
          minVal1 = sortedBarData[ 0 ].value + sortedBarData[ 0 ].value * .5;
        }
        barDomain = {
          min: minVal1,
          max: last(sortedBarData).value + last(sortedBarData).value * .25
        };
      }

      let realMax, realMin;
      realMin = barDomain.min < chartDomain1.min ? barDomain.min : chartDomain1.min;
      realMax = barDomain.max > chartDomain1.max ? barDomain.max : chartDomain1.max;


      const data = prepareDataInteraction.map((row, index) => ({
        ...row,
        index,
      }));

      let chartDomain = {};

      const sortedData = sortBy(data, item => item.value);

      const dataCount = prepareDataInteraction.length;

      if (dataCount > 0) {
        let minVal = 0;
        if (sortedData[ 0 ].value < 0) {
          minVal = sortedData[ 0 ].value + sortedData[ 0 ].value * .5;
        }

        chartDomain = {
          min: minVal,
          max: last(sortedData).value + last(sortedData).value * .25
        };
      }
      if (dataCount == 0 && dataCount1 == 0) {
        return (
          <View style={styles.notice}>
            <Small>{messages[ NO_DATA_TEXT ]}</Small>
          </View>
        );
      }

      const customWidth = screen.isSmall ? screen.width : screen.width * 0.30;
      const animated = selectedInteractionValue != null ? false : undefined;

      return (
        <View>
          <View style={styles.root}>
            <Text
              style={{ paddingTop: 15, textAlign: 'center', fontSize: 18 }}
            >
              <FormattedMessage
                id={'app.portfolio.dashboard.performance.chartHeader'}
                values={{ prefCurrency: displayedCurrency }}
              /></Text>
            {startDate &&
            <Text
              style={{ paddingTop: 5, textAlign: 'center', fontSize: 14, paddingBottom: 20 }}>
              <FormattedMessage
                id={'app.portfolio.dashboard.performance.startDate'}
                values={{ startDate }}
              />
            </Text>
           }
            <View>
              <Chart
                id="bar-chart-test"
                axis={{
                  x: {
                    accessor: ({ index }) => index,
                    scale: scaleBar,
                  },
                  y: {
                    accessor: row => row.value,
                    domain: [ realMin, realMax ],
                  },
                  y2: {
                    accessor: row => row.cumulativeVal,
                    domain: [ realMin, realMax],
                  },
                }}
                animated={animated}
                {...this.props}
                data={data}
                margins={{
                    top: 40,
                    left: 174,
                    right: 183,
                    bottom: 25,
                  }}
                paddings={{
                  left: 80,
                  right: 2,
                  top: 0,
                  bottom: 0,
                }}
                  maxHeight = {350}
                  ratio = {1}
              >
                <XAxis
                  tickFormatter={(i) =>
                    `${
                      messages[
                      'app.portfolio.cumulativeChrt.' + data[ i ].titleText
                        ]
                      }`}
                      
                  showTicks={false}
                  showLine={true}
                  fontSize={20}
                  lineSpacing={2}
                  key="xaxis"
                  // axis="x2"
                />
                <YAxis
                  tickFormatter={(i) =>
                    (i.toString().indexOf('.') == -1 && i.toString().length == 1) || (i.toString().indexOf('.') == -1 && i > -10 && i<=0 ) ? (`${i}.0 %`).toString() : (`${i} %`)
                  }
                  showLine={false}
                  position="start"
                  fontSize={20}
                  labelVerticalPadding={18}
                  lineSpacing={2}
                  key="yaxis"
                  
                />
                <BarChart
                  color={PALETTE.performanceChart}
                  renderBar={
                    (options) => (<Bar
                      {...options}
                      lineColor="transparent"
                      opacity={1}
                      barWidth= {25}
                    />)
                  }
                >
                </BarChart>
                <Grid key="grid"/>
                <LineChart key="line" yAxis="y2" color={PALETTE.primaryActive}/>
                {this.getOuterComponents()}
              </Chart>
            </View>
          </View>
        </View>
      );
    }
  }
}

export default createContainer({
  $queries: {
    screen: {
      width: true,
      height: true,
      isSmall: true,
    },
    i18n: {
      messages: true,
    },

  },

})(CumulativeChart);

